import {
	CurrentInteractionState,
	useCurrentInteractionStore,
} from "@/common/stores/nonpersistingStores/currentInteraction";
import { WrapUpState, useWrapUpStore } from "@/common/stores/nonpersistingStores/wrapup";
import { CustomerHistoryMediaType, InteractionType } from "@/common/types";
import { useMemo } from "react";

export interface CustomerHistoryHookData {
	customerHistoryType: CustomerHistoryMediaType | undefined;
}

export const useCustomerHistory = (): CustomerHistoryHookData => {
	const wrapUp = useWrapUpStore((state: WrapUpState) => state.wrapUp);

	const currentInteraction = useCurrentInteractionStore(
		(state: CurrentInteractionState) =>
			state.preview ? state.preview : state.active
	);

	const customerHistoryType = useMemo<
		CustomerHistoryMediaType | undefined
	>(() => {
		if (wrapUp) {
			return CustomerHistoryMediaType.WrapUp;
		}
		switch (currentInteraction?.type) {
			case InteractionType.Call:
				return CustomerHistoryMediaType.Call;
			case InteractionType.Email:
				return CustomerHistoryMediaType.Email;
			case InteractionType.Voicemail:
				return CustomerHistoryMediaType.Voicemail;
			case InteractionType.WhatsApp:
				return CustomerHistoryMediaType.WhatsApp;
			case InteractionType.Webchat:
				return CustomerHistoryMediaType.Webchat;
		}

		return undefined;
	}, [wrapUp, currentInteraction, currentInteraction?.type]);

	return { customerHistoryType };
};
